import { useEffect, useState } from "react";
import { closeModal, Modal, openModal } from "risa-oasis-ui_v2";

const DELETE_FORM_MATRIX_CONFIRM_ID = "delete-form-matrix-confirm";

interface DeleteFormMatrixConfirmProps {
  formName: string | null;
  onDelete: (formName: string) => Promise<void>;
  onClose: () => void;
}

const DeleteFormMatrixConfirm = ({
  formName,
  onDelete,
  onClose,
}: DeleteFormMatrixConfirmProps) => {
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (formName) {
      openModal(DELETE_FORM_MATRIX_CONFIRM_ID);
    }
  }, [formName]);

  const handleConfirm = async () => {
    if (!formName) return;
    setDeleting(true);
    try {
      await onDelete(formName);
    } finally {
      setDeleting(false);
      closeModal(DELETE_FORM_MATRIX_CONFIRM_ID);
      onClose();
    }
  };

  const handleCancel = () => {
    if (deleting) return;
    closeModal(DELETE_FORM_MATRIX_CONFIRM_ID);
    onClose();
  };

  if (!formName) return null;

  return (
    <Modal
      dialogId={DELETE_FORM_MATRIX_CONFIRM_ID}
      title="Delete Form Matrix Entry"
      saveButtonText={deleting ? "Deleting..." : "Yes, Delete"}
      cancelText="Cancel"
      onSave={handleConfirm}
      onCancel={handleCancel}
      onClose={handleCancel}
      disableSave={deleting}
      autoCloseOnSave={false}
    >
      <div className="flex flex-col items-center justify-center gap-3 py-2">
        <div className="text-center text-sm text-primaryGray-3">
          Are you sure you want to delete{" "}
          <span className="font-semibold">{formName}</span>? This action cannot
          be undone.
        </div>
      </div>
    </Modal>
  );
};

export default DeleteFormMatrixConfirm;
